import 'css-chunksrc/client/pages/documentsPage/reportsPage/header/styles.scss';export default {
  "report": "_report_1v92l_1",
  "header": "_header_1v92l_7",
  "headerItem": "_headerItem_1v92l_14",
  "title": "_title_1v92l_33"
};